export default "__VITE_ASSET__90fa8539__"